module.exports = __webpack_public_path__ + "static/media/sla-expired.91947a81.svg";